!(function () {
    var e,
        t = {
            1092: function (e, t, i) {
                "use strict";
                i.d(t, {
                    M: function () {
                        return s;
                    },
                });
                var r = i(6072),
                    n = i(1717);
                i(1727),
                    document.addEventListener("DOMContentLoaded", function () {
                        document.querySelectorAll(".icon").forEach((e) => {
                            e.classList.add("loaded");
                        }),
                            document.querySelectorAll('a[target="_blank"]').forEach((e) => {
                                e.innerHTML =
                                    e.innerHTML +
                                    '<span class="visually-hidden"> ' +
                                    accessibilityNoticeNewTab +
                                    "</span>";
                            }),
                            (0, n.f)();
                    }),
                    void 0 !== window.BOOMR &&
                        console.log(
                            "Built with " +
                                window.BOOMR.themeName +
                                " (https://themes.shopify.com/themes/align/) version " +
                                window.BOOMR.themeVersion +
                                " by Company XYZ (https://companyxyz.io/)."
                        ),
                    void 0 === window.Shopify && (window.Shopify = {}),
                    (Shopify.bind = function (e, t) {
                        return function () {
                            return e.apply(t, arguments);
                        };
                    }),
                    (Shopify.setSelectorByValue = function (e, t) {
                        for (var i = 0, r = e.options.length; i < r; i++) {
                            var n = e.options[i];
                            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
                        }
                    }),
                    (Shopify.addListener = function (e, t, i) {
                        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
                    }),
                    (Shopify.postLink = function (e, t) {
                        var i = (t = t || {}).method || "post",
                            r = t.parameters || {},
                            n = document.createElement("form");
                        for (var s in (n.setAttribute("method", i), n.setAttribute("action", e), r)) {
                            var o = document.createElement("input");
                            o.setAttribute("type", "hidden"),
                                o.setAttribute("name", s),
                                o.setAttribute("value", r[s]),
                                n.appendChild(o);
                        }
                        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
                    }),
                    (Shopify.CountryProvinceSelector = function (e, t, i) {
                        (this.countryEl = document.getElementById(e)),
                            (this.provinceEl = document.getElementById(t)),
                            (this.provinceContainer = document.getElementById(i.hideElement || t)),
                            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
                            this.initCountry(),
                            this.initProvince();
                    }),
                    (Shopify.CountryProvinceSelector.prototype = {
                        initCountry: function () {
                            var e = this.countryEl.getAttribute("data-default");
                            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
                        },
                        initProvince: function () {
                            var e = this.provinceEl.getAttribute("data-default");
                            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
                        },
                        countryHandler: function (e) {
                            var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
                                    "data-provinces"
                                ),
                                i = JSON.parse(t);
                            if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
                                this.provinceContainer.style.display = "none";
                            else {
                                for (var r = 0; r < i.length; r++) {
                                    var n;
                                    ((n = document.createElement("option")).value = i[r][0]),
                                        (n.innerHTML = i[r][1]),
                                        this.provinceEl.appendChild(n);
                                }
                                this.provinceContainer.style.display = "";
                            }
                        },
                        clearOptions: function (e) {
                            for (; e.firstChild; ) e.removeChild(e.firstChild);
                        },
                        setOptions: function (e, t) {
                            var i = 0;
                            for (t.length; i < t.length; i++) {
                                var r = document.createElement("option");
                                (r.value = t[i]), (r.innerHTML = t[i]), e.appendChild(r);
                            }
                        },
                    }),
                    document.querySelectorAll("video").forEach((e) => {
                        (e.muted = !0),
                            new IntersectionObserver(
                                (t) => {
                                    t.forEach((t) => {
                                        t.isIntersecting
                                            ? 1 == e.autoplay &&
                                              e.paused &&
                                              e.play().catch((e) => {
                                                  "AbortError" !== e.name && console.error("Error playing video:", e);
                                              })
                                            : e.pause();
                                    });
                                },
                                { threshold: 0 }
                            ).observe(e);
                    }),
                    document.querySelectorAll("video.hover-play").forEach((e) => {
                        const t = e.closest(".card");
                        e.pause(),
                            t
                                ? (t.addEventListener("mouseenter", () => {
                                      e.play().catch((e) => {
                                          "AbortError" !== e.name && console.error("Error playing video:", e);
                                      });
                                  }),
                                  t.addEventListener("mouseleave", () => {
                                      e.pause();
                                  }))
                                : (e.addEventListener("mouseenter", () => {
                                      e.play().catch((e) => {
                                          "AbortError" !== e.name && console.error("Error playing video:", e);
                                      });
                                  }),
                                  e.addEventListener("mouseleave", () => {
                                      e.pause();
                                  }));
                    });
                const s = function () {
                    [].slice.call(document.querySelectorAll("video")).forEach((e) => {
                        const t = e.parentElement.querySelector(".figure--video__poster");
                        t &&
                            t.addEventListener("click", () => {
                                t.classList.add("hidden"), e.play();
                            });
                    });
                    var e = [].slice.call(document.querySelectorAll(".figure--video-external"));
                    if ("IntersectionObserver" in window) {
                        var t = new IntersectionObserver(function (e, t) {
                            e.forEach(function (e) {
                                if (e.isIntersecting)
                                    "vimeo" == e.target.dataset.type &&
                                        fetch("http://vimeo.com/api/v2/video/" + e.target.dataset.id + ".json")
                                            .then((e) => {
                                                if (!e.ok) throw new Error(`HTTP error ${e.status}`);
                                                return e.json();
                                            })
                                            .then((t) => {
                                                e.target.querySelector(".figure--video__external-poster-image").src =
                                                    t[0].thumbnail_large;
                                            }),
                                        e.target.addEventListener("click", function () {
                                            if (!e.target.querySelector("iframe")) {
                                                let e = this.dataset.type,
                                                    t = document.createElement("iframe");
                                                t.setAttribute("frameborder", "0"),
                                                    t.setAttribute("allowfullscreen", ""),
                                                    t.setAttribute("allow", "autoplay"),
                                                    "youtube" == e
                                                        ? (t.setAttribute("id", "youtube"),
                                                          t.setAttribute(
                                                              "src",
                                                              "https://www.youtube.com/embed/" +
                                                                  this.dataset.id +
                                                                  this.dataset.videotags +
                                                                  "rel=0&showinfo=0&autoplay=1"
                                                          ))
                                                        : t.setAttribute(
                                                              "src",
                                                              "https://player.vimeo.com/video/" +
                                                                  this.dataset.id +
                                                                  this.dataset.videotags +
                                                                  "rel=0&showinfo=0&autoplay=1"
                                                          ),
                                                    this.appendChild(t),
                                                    setTimeout(() => {
                                                        this.querySelector(".figure--video__poster").classList.add(
                                                            "hidden"
                                                        );
                                                    }, 350);
                                            }
                                        });
                                else if (e.target.querySelector("iframe")) {
                                    let i = e.target.dataset.type,
                                        r = e.target.querySelectorAll("iframe");
                                    if ("youtube" == i) {
                                        var t = { event: "command", func: "pauseVideo" };
                                        r[0].contentWindow.postMessage(JSON.stringify(t), "*");
                                    } else
                                        "vimeo" == i &&
                                            ((t = { method: "pause", value: "true" }),
                                            r[0].contentWindow.postMessage(JSON.stringify(t), "*"));
                                }
                            });
                        });
                        e.forEach(function (e) {
                            t.observe(e);
                        });
                    }
                };
                s(),
                    window.addEventListener("beforeprint", () => {
                        const e = document.body.querySelectorAll("details"),
                            t = document.body.querySelectorAll("img");
                        for (let t = 0; t < e.length; t++)
                            e[t].open ? (e[t].dataset.open = "1") : e[t].setAttribute("open", "");
                        for (let e = 0; e < t.length; e++) t[e].dataset.open = "1";
                    }),
                    window.addEventListener("afterprint", () => {
                        const e = document.body.querySelectorAll("details");
                        for (let t = 0; t < e.length; t++)
                            e[t].dataset.open ? (e[t].dataset.open = "") : e[t].removeAttribute("open");
                    }),
                    Shopify.designMode &&
                        document.addEventListener("shopify:section:load", () => {
                            s(),
                                document.querySelectorAll(".icon").forEach((e) => {
                                    e.classList.add("loaded");
                                });
                        });
                class o extends HTMLElement {
                    constructor() {
                        super(),
                            this.addEventListener("change", (e) => {
                                const t = new CustomEvent("variant-update", {
                                    detail: {
                                        event: e,
                                        section: this.dataset.section,
                                        product: this.dataset.product,
                                        block: this.dataset.block,
                                    },
                                    bubbles: !0,
                                });
                                this.dispatchEvent(t);
                            }),
                            document.addEventListener("variant-update", (e) => {
                                this.dataset.section === e.detail.section &&
                                    this.dataset.product === e.detail.product &&
                                    this.dataset.block === e.detail.block &&
                                    (e.detail.event.target.closest("variant-selects") !== this &&
                                        this.syncSelection(e.detail.event.target),
                                    this.onVariantChange());
                            }),
                            (this.isCardBasedProductForm = null !== this.closest(".card__content"));
                    }
                    connectedCallback() {
                        (this.mainProductUniqueIdentifier = "main-product-" + this.dataset.product),
                            (this.uniqueIdentifier =
                                this.dataset.section +
                                "-" +
                                this.dataset.product +
                                (this.dataset.block ? "-" + this.dataset.block : ""));
                    }
                    onVariantChange() {
                        this.updateOptions(),
                            this.updateMasterId(),
                            this.currentVariant
                                ? (this.updateVariantStatuses(),
                                  this.updateImageSwatches(),
                                  this.updateMedia(),
                                  this.updateURL(),
                                  this.updateLinks(),
                                  this.renderProductInfo(),
                                  this.updateVariantInput(),
                                  this.updateAddToCart())
                                : void 0 === this.currentVariant && this.setUnavailable();
                    }
                    syncSelection(e) {
                        const { name: t, value: i } = e,
                            r = this.querySelector(`[name="${t}"]`),
                            n = r?.tagName;
                        r &&
                            ("SELECT" === n
                                ? (this.querySelector(`[name="${t}"] [value="${i}"]`).selected = !0)
                                : (this.querySelector(`[name="${t}"][value="${i}"]`).checked = !0));
                    }
                    updateOptions() {
                        this.options = Array.from(this.querySelectorAll("select, fieldset"), (e) =>
                            "SELECT" === e.tagName
                                ? e.value
                                : "FIELDSET" === e.tagName
                                  ? Array.from(e.querySelectorAll("input")).find((e) => e.checked)?.value
                                  : void 0
                        );
                    }
                    updateMasterId() {
                        this.options.includes(void 0)
                            ? (this.currentVariant = null)
                            : (this.currentVariant = this.getVariantData().find(
                                  (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
                              ));
                    }
                    updateVariantStatuses() {
                        const e = this.querySelector(":checked").value,
                            t = this.getVariantData().filter((t) => t.options[0] === e);
                        this.getProductVariantSelects().forEach((e) => {
                            const i = e.querySelectorAll("select, fieldset");
                            i.forEach((e, r) => {
                                if (0 === r) return;
                                const n = e.querySelectorAll('input[type="radio"], option'),
                                    s = i[r - 1].querySelector(":checked").value,
                                    o = t
                                        .filter((e) => e.available && e[`option${r}`] === s)
                                        .map((e) => e[`option${r + 1}`]);
                                this.setInputAvailability(n, o);
                            });
                        });
                    }
                    setInputAvailability(e, t) {
                        e.forEach((e) => {
                            const i = e.getAttribute("value"),
                                r = t.includes(i);
                            "OPTION" === e.tagName &&
                                (e.innerText = r
                                    ? i
                                    : window.productStrings.unavailable_with_option.replace("[value]", i));
                        });
                    }
                    updateImageSwatches() {
                        this.querySelectorAll("fieldset:has(.image-swatch)").forEach((e) => {
                            const t = e.dataset.optionPosition,
                                i = e.querySelectorAll(".image-swatch");
                            for (const e of i) {
                                const i = [...this.options];
                                i[t - 1] = e.value;
                                const r = this.getVariantData().find(
                                    (e) => e.options[0] == i[0] && e.options[1] == i[1] && e.options[2] == i[2]
                                );
                                if (!r) continue;
                                const n = e.labels[0],
                                    s = n.querySelectorAll("img.variant-image"),
                                    o = n.querySelector(`img[data-variant-id="${r.id}"]`),
                                    a = n.querySelector(".image_swatch--text_value");
                                s.forEach((e) => {
                                    e.classList.add("hidden");
                                }),
                                    a.classList.add("u-hide"),
                                    o ? o.classList.remove("hidden") : a.classList.remove("u-hide");
                            }
                        });
                    }
                    updateMedia() {
                        if (!this.currentVariant) return;
                        if (!this.currentVariant.featured_media) return;
                        const e = document.querySelector(`#gallery-${this.uniqueIdentifier}`),
                            t = e.dataset.variantStyle;
                        if (this.currentVariant.featured_media) {
                            const i = this.currentVariant.featured_media.id;
                            if ("default" == t)
                                if (e.swiper.initialized) {
                                    const t = e.swiper.virtual?.slides?.length
                                            ? e.swiper.virtual.slides
                                            : e.swiper.slides,
                                        r = Array.from(t).findIndex((e) => e.dataset.id == i);
                                    -1 !== r && e.swiper.slideToLoop(r);
                                } else {
                                    const t = e.querySelector(`[data-id="${i}"]`);
                                    t && e.prepend(t);
                                }
                            else if ("variant" == t) {
                                const t = e.querySelector(`[data-id="${i}"]`);
                                t && (e.firstChild.classList.add("u-hide"), t.classList.remove("u-hide"), e.prepend(t));
                            }
                            const r = document.querySelector(`#sticky-gallery-${this.uniqueIdentifier}`);
                            if (r) {
                                const e = r.querySelectorAll(".sticky-add-to-cart__image"),
                                    t = this.currentVariant.id;
                                e.forEach((e) => {
                                    e.dataset.variantId == t ? e.classList.remove("u-hide") : e.classList.add("u-hide");
                                });
                            }
                        }
                    }
                    updateURL() {
                        if ("false" === this.dataset.updateUrl) return;
                        const e = `${this.dataset.url}?variant=${this.currentVariant.id}`;
                        window.history.replaceState({}, "", e);
                    }
                    updateLinks() {
                        if (!this.isCardBasedProductForm) return;
                        const e = this.closest(".card__content").querySelector(".button--view-product");
                        "A" === e?.tagName &&
                            (e.href = this.dataset.url.split("?")[0] + `?variant=${this.currentVariant.id}`);
                    }
                    updateVariantInput() {
                        document
                            .querySelectorAll(
                                `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
                            )
                            .forEach((e) => {
                                const t = e.querySelector('input[name="id"]');
                                (t.value = this.currentVariant.id),
                                    t.dispatchEvent(new Event("change", { bubbles: !0 }));
                            });
                    }
                    renderProductInfo() {
                        const e = document.getElementById(`price-${this.uniqueIdentifier}`);
                        e &&
                            (e.classList.contains("price--on-sale")
                                ? e
                                      .querySelectorAll(".price__sale .price-item")
                                      .forEach((e) => e.classList.add("skeleton-loading"))
                                : e.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const t = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        t &&
                            (t.classList.contains("price--on-sale")
                                ? t
                                      .querySelectorAll(".price__sale .price-item")
                                      .forEach((e) => e.classList.add("skeleton-loading"))
                                : t.querySelector(".price__regular").classList.add("skeleton-loading"));
                        const i = document.getElementById(`pickup-availability-${this.uniqueIdentifier}`);
                        i?.querySelector(".skeleton-loading-wrapper")?.classList.add("skeleton-loading");
                        const n = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        n?.classList.add("skeleton-loading");
                        const s = document.getElementById(`pickup-availability-modal-${this.uniqueIdentifier}`);
                        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
                            .then((e) => e.text())
                            .then((o) => {
                                const a = new DOMParser().parseFromString(o, "text/html"),
                                    l = a.getElementById(`price-${this.mainProductUniqueIdentifier}`);
                                if (n) {
                                    const e = a.getElementById(`stock-status-${this.mainProductUniqueIdentifier}`);
                                    e
                                        ? (n.classList.remove("u-invisible"),
                                          (n.innerHTML = e.innerHTML),
                                          (n.classList = e.classList))
                                        : n?.classList.add("u-invisible");
                                }
                                if (
                                    (l && e
                                        ? (e.classList.remove("u-invisible"),
                                          (e.innerHTML = l.innerHTML),
                                          (e.classList = l.classList))
                                        : e?.classList.add("u-invisible"),
                                    t)
                                ) {
                                    const e = a.getElementById(`sticky-price-${this.mainProductUniqueIdentifier}`);
                                    e
                                        ? (t.classList.remove("u-invisible"),
                                          (t.innerHTML = e.innerHTML),
                                          (t.classList = e.classList))
                                        : t?.classList.add("u-invisible");
                                }
                                if (i) {
                                    const e = a.getElementById(
                                        `pickup-availability-${this.mainProductUniqueIdentifier}`
                                    );
                                    e && ((i.innerHTML = e.innerHTML), (i.classList = e.classList));
                                }
                                if (s) {
                                    const e = a.getElementById(
                                        `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
                                    );
                                    e && (s.innerHTML = e.innerHTML);
                                }
                                const c = document.querySelector(".pickup-availability"),
                                    d = document.getElementById("overlay"),
                                    u = document.getElementById("pickup-availability-open"),
                                    h = document.getElementById("pickup-availability-close");
                                u &&
                                    document
                                        .getElementById("pickup-availability-open")
                                        .addEventListener("click", function () {
                                            c.classList.add("open"),
                                                d.classList.add("open"),
                                                document.body.classList.add("active", "minicart"),
                                                (0, r.hO)(!0);
                                        }),
                                    h &&
                                        document
                                            .getElementById("pickup-availability-close")
                                            .addEventListener("click", function () {
                                                c.classList.remove("open"),
                                                    document.body.classList.remove("active", "minicart"),
                                                    (0, r.hO)(!1),
                                                    overlay.classList.remove("open", "overlay--all"),
                                                    (0, r.zx)(c);
                                            });
                            });
                    }
                    updateAddToCart() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`);
                        e &&
                            (this.currentVariant.available
                                ? e.forEach((e) => {
                                      const t = e.querySelector('[name="add"]'),
                                          i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                                      t &&
                                          (t.removeAttribute("disabled"), (i.textContent = `${cartStrings.addToCart}`));
                                  })
                                : e.forEach((e) => {
                                      const t = e.querySelector('[name="add"]'),
                                          i = e.querySelector('[name="add"] > span:not(.cart-icon)');
                                      t &&
                                          (t.setAttribute("disabled", "disabled"),
                                          (i.textContent = `${cartStrings.soldOut}`));
                                  }));
                    }
                    setUnavailable() {
                        const e = document.querySelectorAll(`.form-product-${this.uniqueIdentifier}`),
                            t = document.getElementById(`stock-status-${this.uniqueIdentifier}`);
                        e.forEach((e) => {
                            const i = e.querySelector('[name="add"]'),
                                r = e.querySelector('[name="add"] > span:not(.cart-icon)');
                            i &&
                                ((r.textContent = `${cartStrings.unavailable}`),
                                i.setAttribute("disabled", "disabled"),
                                t && (t.dataset.state = "unavailable"));
                        });
                        const i = document.getElementById(`price-${this.uniqueIdentifier}`),
                            r = document.getElementById(`sticky-price-${this.uniqueIdentifier}`);
                        i && this.setPriceUnavailable(i), r && this.setPriceUnavailable(r);
                    }
                    setPriceUnavailable(e) {
                        e.classList.remove("price--on-sale"),
                            e.classList.add("price--sold-out"),
                            (e.querySelector(".price__regular .price-item.price-item--regular").textContent =
                                window.productStrings.price_unavailable);
                    }
                    getVariantData() {
                        return (
                            (this.variantData =
                                this.variantData ||
                                JSON.parse(this.querySelector('[type="application/json"]').textContent)),
                            this.variantData
                        );
                    }
                    getProductVariantSelects() {
                        return document.querySelectorAll(
                            `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"][data-block="${this.dataset.block}"]`
                        );
                    }
                }
                customElements.get("variant-selects") || customElements.define("variant-selects", o);
                class a {
                    constructor(e) {
                        (this.el = e),
                            (this.summary = e.querySelector("summary")),
                            (this.content = e.querySelector(".content")),
                            (this.animation = null),
                            (this.isClosing = !1),
                            (this.isExpanding = !1),
                            this.summary.addEventListener("click", (e) => this.onClick(e));
                    }
                    onClick(e) {
                        e.preventDefault(),
                            (this.el.style.overflow = "hidden"),
                            this.isClosing || !this.el.open
                                ? this.open()
                                : (this.isExpanding || this.el.open) && this.shrink();
                    }
                    shrink() {
                        this.isClosing = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate(
                                { height: [e, t] },
                                { duration: 400, easing: "ease-out" }
                            )),
                            (this.animation.onfinish = () => this.onAnimationFinish(!1)),
                            (this.animation.oncancel = () => (this.isClosing = !1));
                    }
                    open() {
                        (this.el.style.height = `${this.el.offsetHeight}px`),
                            (this.el.open = !0),
                            window.requestAnimationFrame(() => this.expand());
                    }
                    expand() {
                        this.isExpanding = !0;
                        const e = `${this.el.offsetHeight}px`,
                            t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
                        this.animation && this.animation.cancel(),
                            (this.animation = this.el.animate(
                                { height: [e, t] },
                                { duration: 400, easing: "ease-out" }
                            )),
                            (this.animation.onfinish = () => this.onAnimationFinish(!0)),
                            (this.animation.oncancel = () => (this.isExpanding = !1));
                    }
                    onAnimationFinish(e) {
                        (this.el.open = e),
                            (this.animation = null),
                            (this.isClosing = !1),
                            (this.isExpanding = !1),
                            (this.el.style.height = this.el.style.overflow = "");
                    }
                }
                document.querySelectorAll("details.accordion__wrapper").forEach((e) => {
                    new a(e);
                });
            },
            157: function (e, t, i) {
                "use strict";
                var r = i(6072),
                    n = i(1717),
                    s = i(1434),
                    o = (i(4056), i(3643)),
                    a = i(1092);
                const l = new s.Z(),
                    c = () => {
                        const e = document.querySelectorAll("#ProductGridContainer .card").length;
                        e < 6 && document.querySelectorAll(".banner--large").forEach((e) => (e.style.display = "none")),
                            e < 6 &&
                                document.querySelectorAll(".banner--small").forEach((e) => (e.style.display = "none"));
                    };
                class d extends HTMLElement {
                    constructor() {
                        super(),
                            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
                            (this.handleMobileSort = this.handleMobileSort.bind(this)),
                            (this.handleSortForm = this.handleSortForm.bind(this)),
                            (this.handleFilterForm = this.handleFilterForm.bind(this)),
                            (this.debouncedOnSubmit = (0, r.Ds)((e) => {
                                this.onSubmitHandler(e);
                            }, 500)),
                            this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this)),
                            this.setupMobileSort();
                    }
                    setupMobileSort() {
                        const e = document.querySelector("#SortByMobile");
                        e &&
                            (e.removeEventListener("change", this.handleMobileSort),
                            e.addEventListener("change", this.handleMobileSort));
                    }
                    handleMobileSort(e) {
                        const t = document.querySelector("#FacetSortForm");
                        if (t) {
                            const i = t.querySelector("select");
                            i && ((i.value = e.target.value), this.debouncedOnSubmit(e));
                        }
                    }
                    handleSortForm(e) {
                        const t = document.querySelector("#FacetFiltersForm");
                        let i = "";
                        if (t) {
                            const e = new FormData(t);
                            i = new URLSearchParams(e).toString();
                        }
                        const r = this.createSearchParams(e);
                        return i ? `${i}&${r}` : r;
                    }
                    handleFilterForm() {
                        const e = [],
                            t = document.querySelectorAll("form.facet-form"),
                            i = ["FacetAvailabilityForm", "FacetSortForm", "FacetFiltersForm", "FacetSearchForm"];
                        t.forEach((t) => {
                            if (i.includes(t.id)) {
                                const i = this.createSearchParams(t);
                                "" !== i && e.push(i);
                            }
                        });
                        const r = e.join("&").split("&");
                        return [...new Set(r)].join("&");
                    }
                    onSubmitHandler(e) {
                        e.preventDefault();
                        const t = e.target.closest("form");
                        if (!t) return;
                        if ("FacetSortForm" === t.id) {
                            const i = this.handleSortForm(t);
                            return void this.onSubmitForm(i, e);
                        }
                        const i = this.handleFilterForm();
                        this.onSubmitForm(i, e);
                    }
                    static renderFilters(e, t) {
                        const i = new DOMParser().parseFromString(e, "text/html"),
                            r =
                                "#FacetFiltersForm .js-filter, #FacetAvailabilityForm .js-filter, #FacetSortForm .js-filter",
                            n = i.querySelectorAll(r),
                            s = document.querySelectorAll(r);
                        Array.from(s).forEach((e) => {
                            Array.from(n).some((t) => {
                                let { id: i } = t;
                                return e.id === i;
                            }) || e.remove();
                        });
                        const o = (e) => {
                                const i = t ? t.target.closest(".js-filter") : void 0;
                                return !!i && e.id === i.id;
                            },
                            a = Array.from(n).filter((e) => !o(e));
                        a.forEach((e, t) => {
                            if (document.getElementById(e.id)) document.getElementById(e.id).innerHTML = e.innerHTML;
                            else {
                                if (t > 0) {
                                    const { className: i, id: r } = a[t - 1];
                                    if (e.className === i) return void document.getElementById(r).after(e);
                                }
                                if (e.parentElement) {
                                    const t = document.querySelector(`#${e.parentElement.id} .js-filter`);
                                    t ? t.before(e) : e.parentElement.appendChild(e);
                                }
                            }
                        });
                        const l = document.querySelector("facet-filters-form");
                        l && l.setupMobileSort();
                        const c = Array.from(n).find(o);
                        c && t.target.closest(".js-filter").id && d.renderCounts(c, t.target.closest(".js-filter")),
                            d.renderAdditionalElements(i);
                    }
                    static setListeners() {
                        window.addEventListener("popstate", (e) => {
                            const t = e.state ? e.state.searchParams : d.searchParamsInitial;
                            t !== d.searchParamsPrev && d.renderPage(t, null, !1);
                        });
                    }
                    static renderPage(e, t) {
                        let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                        d.searchParamsPrev = e;
                        const r = d.getSections();
                        document.getElementById("ProductGridContainer").classList.add("loading"),
                            r.forEach((i) => {
                                const r = `${window.location.pathname}?section_id=${i.section}&${e}`,
                                    n = (e) => e.url === r;
                                d.filterData.some(n) ? d.renderSectionFromCache(n, t) : d.renderSectionFromFetch(r, t);
                            }),
                            i && d.updateURLHash(e);
                    }
                    static renderSectionFromFetch(e, t) {
                        fetch(e)
                            .then((e) => e.text())
                            .then((i) => {
                                const n = i;
                                (d.filterData = [...d.filterData, { html: n, url: e }]),
                                    d.renderFilters(n, t),
                                    d.renderProductGridContainer(n),
                                    document.getElementById("ProductGridContainer").classList.remove("loading"),
                                    (0, r.X5)(
                                        document.querySelector("div.grid-archive__outer-container"),
                                        document.getElementById("grid-archive-header").offsetHeight
                                    );
                            });
                    }
                    static renderSectionFromCache(e, t) {
                        const i = d.filterData.find(e).html;
                        d.renderFilters(i, t),
                            d.renderProductGridContainer(i),
                            document.getElementById("ProductGridContainer").classList.remove("loading");
                    }
                    static renderProductGridContainer(e) {
                        (document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
                            .parseFromString(e, "text/html")
                            .getElementById("ProductGridContainer").innerHTML),
                            c(),
                            document
                                .getElementById("ProductGridContainer")
                                .querySelectorAll(".icon")
                                .forEach((e) => {
                                    e.classList.add("loaded");
                                }),
                            (0, r.Sw)(),
                            (0, n.f)(),
                            (0, a.M)(),
                            new o.M();
                    }
                    static renderAdditionalElements(e) {
                        this.updateElementFromHTML(".facets__active", e),
                            this.updateElementFromHTML(".facets__clear", e),
                            document.querySelectorAll("facet-filters-form .icon").forEach((e) => {
                                e.classList.add("loaded");
                            });
                    }
                    static updateElementFromHTML(e, t) {
                        for (const s of document.querySelectorAll(e)) {
                            s.innerHTML = t.querySelector(e).innerHTML;
                        }
                    }
                    static renderCounts(e, t) {
                        const i = t.querySelector("summary"),
                            r = e.querySelector("summary");
                        r && i && (i.outerHTML = r.outerHTML);
                    }
                    static updateURLHash(e) {
                        history.pushState({ searchParams: e }, "", `${window.location.pathname}${e && "?".concat(e)}`);
                    }
                    static getSections() {
                        return [{ section: document.getElementById("grid-product").dataset.id }];
                    }
                    createSearchParams(e) {
                        const t = new FormData(e);
                        return new URLSearchParams(t).toString();
                    }
                    onSubmitForm(e, t) {
                        d.renderPage(e, t);
                    }
                    onActiveFilterClick(e) {
                        e.preventDefault();
                        const t = new URL(e.currentTarget.href).search.substring(1);
                        d.renderPage(t);
                    }
                }
                (d.filterData = []),
                    (d.searchParamsInitial = window.location.search.slice(1)),
                    (d.searchParamsPrev = window.location.search.slice(1)),
                    d.setListeners(),
                    customElements.get("facet-filters-form") || customElements.define("facet-filters-form", d);
                class u extends HTMLElement {
                    constructor() {
                        super(),
                            this.querySelector("a").addEventListener("click", (e) => {
                                e.preventDefault(),
                                    (
                                        this.closest("facet-filters-form#facets") ||
                                        document.querySelector("facet-filters-form#facets")
                                    ).onActiveFilterClick(e);
                            });
                    }
                }
                customElements.get("facet-remove") || customElements.define("facet-remove", u);
                class h extends HTMLElement {
                    constructor() {
                        super(), (this.desktopMedia = window.matchMedia("(min-width: 1024px)"));
                    }
                    connectedCallback() {
                        c(), this.toggleSidebar(), (0, r.Sw)();
                    }
                    toggleSidebar = () => {
                        const e = window.matchMedia("(max-width: 1024px)");
                        document.querySelectorAll(".grid-archive").forEach((t) => {
                            const i = t.closest(".shopify-section").querySelector(".toggle-filtering"),
                                n = t.querySelector(".grid-archive__filters-container"),
                                s = () => {
                                    t.classList.remove("grid-archive__main-container--filters-shown"), (0, r.gp)(!1, s);
                                },
                                o = () => {
                                    t.classList.remove("grid-archive__main-container-mobile--filters-shown"),
                                        (0, r.g)(!1, "laptop-down"),
                                        l.close(),
                                        (0, r.gp)(!1, o);
                                },
                                a = (e) => {
                                    e.target.closest(".facets") || (o(), n.removeEventListener("click", a));
                                };
                            i &&
                                i.addEventListener("click", () => {
                                    e.matches
                                        ? (t.classList.add("grid-archive__main-container-mobile--filters-shown"),
                                          (0, r.g)(!0, "laptop-down"),
                                          l.open({ attachElements: [n] }),
                                          (0, r.gp)(!0, o),
                                          n.addEventListener("click", a))
                                        : t.classList.contains("grid-archive__main-container--filters-shown")
                                          ? s()
                                          : (t.classList.add("grid-archive__main-container--filters-shown"),
                                            (0, r.gp)(!0, s));
                                }),
                                n &&
                                    n.querySelector(".facets__mobile-close").addEventListener("click", (e) => {
                                        e.preventDefault(), o();
                                    }),
                                e.addEventListener("change", () => {
                                    t.classList.contains("grid-archive__main-container-mobile--filters-shown") && o();
                                });
                        });
                    };
                    syncSorts = () => {
                        if (0 == document.querySelectorAll("#SortByMobile").length) return;
                        const e = document.querySelectorAll("#SortBy, #SortByMobile");
                        e.forEach((t) => {
                            t.addEventListener("change", function (t) {
                                e.forEach((e) => {
                                    e.value = t.target.value;
                                });
                                const i = new Event("input");
                                document.querySelector("#FacetSortForm").dispatchEvent(i);
                            });
                        });
                    };
                }
                customElements.get("filters-component") || customElements.define("filters-component", h);
            },
            1727: function () {
                class e extends HTMLElement {
                    constructor() {
                        super(),
                            (this.elements = {
                                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                                details: this.querySelector("details"),
                                summary: this.querySelector("summary"),
                                links: this.querySelectorAll("ul a"),
                            }),
                            this.elements.links.forEach((e) =>
                                e.addEventListener("click", this.onItemClick.bind(this))
                            ),
                            (this.handleClickOutside = this.handleClickOutside.bind(this)),
                            document.addEventListener("click", this.handleClickOutside),
                            (this.handleKeyDown = this.handleKeyDown.bind(this)),
                            this.elements.summary?.addEventListener("keydown", this.handleKeyDown),
                            (this.handleDetailsToggle = this.handleDetailsToggle.bind(this)),
                            this.elements.details?.addEventListener("toggle", this.handleDetailsToggle);
                    }
                    onItemClick(e) {
                        e.preventDefault();
                        const t = this.querySelector("form");
                        (this.elements.input.value = e.currentTarget.dataset.value), t && t.submit();
                    }
                    handleClickOutside(e) {
                        this.elements.details &&
                            this.elements.details.hasAttribute("open") &&
                            !this.contains(e.target) &&
                            this.closeDetails();
                    }
                    handleKeyDown(e) {
                        if (!this.elements.details) return;
                        if ("Escape" === e.key && this.elements.details.hasAttribute("open"))
                            return e.preventDefault(), this.closeDetails(), void this.elements.summary?.focus();
                        if (!this.elements.details.hasAttribute("open")) return void (" " === e.key || e.key);
                        const t = Array.from(this.elements.links).indexOf(document.activeElement);
                        switch (e.key) {
                            case "ArrowDown":
                                e.preventDefault();
                                const i = t < this.elements.links.length - 1 ? t + 1 : 0;
                                this.elements.links[i]?.focus();
                                break;
                            case "ArrowUp":
                                e.preventDefault();
                                const r = t > 0 ? t - 1 : this.elements.links.length - 1;
                                this.elements.links[r]?.focus();
                                break;
                            case "Home":
                                e.preventDefault(), this.elements.links[0]?.focus();
                                break;
                            case "End":
                                e.preventDefault(), this.elements.links[this.elements.links.length - 1]?.focus();
                                break;
                            case "Escape":
                                e.preventDefault(), this.closeDetails(), this.elements.summary?.focus();
                        }
                    }
                    handleDetailsToggle() {
                        this.elements.details.hasAttribute("open")
                            ? this.elements.links.forEach((e) => {
                                  e.addEventListener("keydown", this.handleKeyDown), e.setAttribute("tabindex", "0");
                              })
                            : this.elements.links.forEach((e) => {
                                  e.removeEventListener("keydown", this.handleKeyDown),
                                      e.setAttribute("tabindex", "-1");
                              });
                    }
                    closeDetails() {
                        this.elements.details && this.elements.details.removeAttribute("open");
                    }
                    disconnectedCallback() {
                        document.removeEventListener("click", this.handleClickOutside),
                            this.elements.summary?.removeEventListener("keydown", this.handleKeyDown),
                            this.elements.details?.removeEventListener("toggle", this.handleDetailsToggle),
                            this.elements.links.forEach((e) => {
                                e.removeEventListener("keydown", this.handleKeyDown);
                            });
                    }
                }
                customElements.get("localization-form") || customElements.define("localization-form", e);
            },
            4056: function () {
                class e extends HTMLElement {
                    constructor() {
                        super(),
                            (this.fromSlider = this.querySelectorAll("input[type='range']")[0]),
                            (this.toSlider = this.querySelectorAll("input[type='range']")[1]),
                            (this.fromInput = this.querySelectorAll("input[type='number']")[0]),
                            (this.toInput = this.querySelectorAll("input[type='number']")[1]),
                            (this.resetButton = this.querySelector("input[type='button'].range--reset")),
                            (this.mobileLabelFrom = this.querySelector(".range--slider-label-from-value")),
                            (this.mobileLabelTo = this.querySelector(".range--slider-label-to-value")),
                            (this.rangeMin = this.toInput.min),
                            (this.rangeMax = this.toInput.max),
                            (this.rangeDistance = this.rangeMax - this.rangeMin),
                            (this.sliderColor = this.dataset.sliderColor || "#b1b1b1"),
                            (this.rangeColor = this.dataset.rangeColor || "#989898"),
                            this.setSlider(this.fromSlider.value, this.toSlider.value);
                    }
                    addListeners() {
                        this.fromSlider.addEventListener("input", this.updateFromSlider.bind(this)),
                            this.toSlider.addEventListener("input", this.updateToSlider.bind(this)),
                            this.fromInput.addEventListener("input", this.updateFromInput.bind(this)),
                            this.fromInput.addEventListener("keypress", this.validateNumberInput),
                            this.toInput.addEventListener("input", this.updateToInput.bind(this)),
                            this.toInput.addEventListener("keypress", this.validateNumberInput),
                            this.resetButton.addEventListener("click", this.handleResetButtonClick.bind(this));
                    }
                    validateNumberInput(e) {
                        8 === e.charCode || (e.charCode >= 48 && e.charCode <= 57) || e.preventDefault();
                    }
                    connectedCallback() {
                        this.addListeners();
                    }
                    updateFromInput(e) {
                        const [t, i] = this.getParsed(this.fromInput, this.toInput),
                            r = null !== t ? t : Number(this.fromInput.min),
                            n = i || Number(this.toInput.max);
                        r < this.fromInput.min
                            ? (this.fromInput.value = Number(this.fromInput.min))
                            : r > n && (this.fromInput.value = n),
                            this.fromInput.value
                                ? this.fromInput.value <= n
                                    ? (this.setSlider(this.fromInput.value, !1),
                                      (this.mobileLabelFrom.innerHTML = this.fromInput.value),
                                      this.showResetButton())
                                    : e.stopPropagation()
                                : (this.setSlider(r, !1), (this.mobileLabelFrom.innerHTML = r));
                    }
                    updateToInput(e) {
                        const [t, i] = this.getParsed(this.fromInput, this.toInput),
                            r = null !== i ? i : Number(this.toInput.max),
                            n = t || Number(this.fromInput.min);
                        r > this.toInput.max && (this.toInput.value = Number(this.toInput.max)),
                            this.toInput.value
                                ? n <= this.toInput.value
                                    ? (this.setSlider(!1, this.toInput.value),
                                      (this.mobileLabelTo.innerHTML = this.toInput.value),
                                      this.showResetButton())
                                    : e.stopPropagation()
                                : (this.setSlider(!1, r), (this.mobileLabelTo.innerHTML = r));
                    }
                    updateFromSlider() {
                        const [e, t] = this.getParsed(this.fromSlider, this.toSlider);
                        e > t ? ((this.fromSlider.value = t), (this.fromInput.value = t)) : (this.fromInput.value = e),
                            this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 }));
                    }
                    updateToSlider() {
                        const [e, t] = this.getParsed(this.fromSlider, this.toSlider);
                        e <= t ? (this.toInput.value = t) : ((this.toInput.value = e), (this.toSlider.value = e)),
                            this.toInput.dispatchEvent(new Event("input", { bubbles: !0 }));
                    }
                    getParsed(e, t) {
                        return [e.value ? parseInt(e.value, 10) : null, t.value ? parseInt(t.value, 10) : null];
                    }
                    setSlider(e, t) {
                        !1 !== e && (this.fromSlider.value = e), !1 !== t && (this.toSlider.value = t);
                        const i = this.fromSlider.value - this.rangeMin,
                            r = this.toSlider.value - this.rangeMin,
                            n = (i / this.rangeDistance) * 100,
                            s = (r / this.rangeDistance) * 100,
                            o = 8 - 0.15 * n,
                            a = 8 - 0.15 * s;
                        this.fillSlider(n, s, o, a);
                    }
                    fillSlider(e, t, i, r) {
                        this.toSlider.style.background = `linear-gradient(\n      to right,\n      ${this.sliderColor} 0%,\n      ${this.sliderColor} calc(${e}% + ${i}px),\n      ${this.rangeColor} calc(${e}% + ${i}px),\n      ${this.rangeColor} calc(${t}% + ${r}px),\n      ${this.sliderColor} calc(${t}% + ${r}px),\n      ${this.sliderColor} 100%)`;
                    }
                    handleResetButtonClick(e) {
                        e.preventDefault(),
                            e.stopPropagation(),
                            (this.fromInput.value = null),
                            (this.toInput.value = null),
                            this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 })),
                            this.toInput.dispatchEvent(new Event("input", { bubbles: !0 })),
                            this.hideResetButton();
                    }
                    removeListeners() {
                        this.fromSlider.removeEventListener("input", this.updateFromSlider.bind(this)),
                            this.toSlider.removeEventListener("input", this.updateToSlider.bind(this)),
                            this.fromInput.removeEventListener("input", this.updateFromInput.bind(this)),
                            this.toInput.removeEventListener("input", this.updateToInput.bind(this)),
                            this.resetButton.removeEventListener("click", this.handleResetButtonClick.bind(this));
                    }
                    hideResetButton() {
                        this.resetButton.classList.add("hidden");
                    }
                    showResetButton() {
                        this.resetButton.classList.remove("hidden");
                    }
                    disconnectedCallback() {
                        this.removeListeners();
                    }
                }
                customElements.get("price-range") || customElements.define("price-range", e);
            },
            4487: function (e, t, i) {
                "use strict";
                var r = i(6072);
                const n = new (class {
                    constructor() {
                        (this.selectorsToUpdate = [
                            ".cart-summary__header",
                            ".cart-summary__line-items",
                            "#checkout",
                            ".cart-summary__free-shipping",
                        ]),
                            (this.mainCartSelector = ".shopify-section.cart"),
                            (this.miniCart = document.getElementById("mini-cart")),
                            (this.itemsContainersSelector = ".cart-items-container, .cart__empty, .mini-cart--empty"),
                            (this.parser = new DOMParser()),
                            (this._desiredQtyByKey = new Map()),
                            (this._inFlightByKey = new Set()),
                            (this._inventoryBlockedByKey = new Set()),
                            (this._maxQtyByKey = new Map()),
                            (this._errorTimeoutByKey = new Map()),
                            (this._versionByKey = new Map()),
                            (this._deletingByKey = new Set()),
                            (this.debugMode = !0),
                            (this._needsCartRefresh = !1),
                            (this.selectors = {
                                cartItem: ".cart-item",
                                cartItemTotals: ".cart-item__totals",
                                priceItemSale: ".price-item--sale",
                                priceItemRegular: ".price-item--regular",
                                cartItemsContainer: ".cart-items-container",
                                miniCart: "#mini-cart",
                            }),
                            (this.items = Array.from(document.querySelectorAll(".cart-item"))),
                            this.items.forEach((e) => this.manageState(e));
                    }
                    _getCartContainers() {
                        const e = [],
                            t = document.querySelector(this.mainCartSelector);
                        t && e.push({ container: t, name: "mainCart", searchContainer: t });
                        const i = document.getElementById("mini-cart");
                        if (i) {
                            const t = i.querySelector(this.selectors.cartItemsContainer);
                            e.push({ container: i, name: "miniCart", searchContainer: t || i });
                        }
                        return e;
                    }
                    requestQuantityUpdate(e, t) {
                        this._desiredQtyByKey.set(e, t);
                        const i = this._versionByKey.get(e) || 0;
                        this._versionByKey.set(e, i + 1);
                        const r = this._maxQtyByKey.get(e);
                        this._inventoryBlockedByKey.has(e) &&
                            void 0 !== r &&
                            t <= r &&
                            (this._inventoryBlockedByKey.delete(e), this.clearInventoryError(e)),
                            this._inFlightByKey.has(e) || this._processItemUpdate(e);
                    }
                    async _processItemUpdate(e) {
                        this._inFlightByKey.add(e);
                        const t = this._desiredQtyByKey.get(e),
                            i = this._versionByKey.get(e),
                            r = document.querySelector(`.cart-item[data-item-id="${e}"]`);
                        if (!r) return this._inFlightByKey.delete(e), void this._desiredQtyByKey.delete(e);
                        const n = r.getAttribute("data-variant-id");
                        this._setItemBusy(r, !0);
                        try {
                            await this.changeCartItem({ id: n, quantity: t, itemKey: e, requestVersion: i }),
                                this.clearInventoryError(e),
                                this._inventoryBlockedByKey.delete(e);
                        } catch (t) {
                            if ((console.error("Cart update failed:", t), 429 === t.status))
                                await new Promise((e) => setTimeout(e, 300));
                            else if (422 === t.status) {
                                try {
                                    const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`,
                                        i = await fetch(t),
                                        r = await i.text(),
                                        n = this.parser.parseFromString(r, "text/html"),
                                        s = n.querySelector(`.cart-item[data-item-id="${e}"]`);
                                    if (s) {
                                        const t = s.querySelector('input[name="quantity"]'),
                                            i = (t && parseInt(t.value)) || 1;
                                        this._maxQtyByKey.set(e, i),
                                            this._desiredQtyByKey.set(e, i),
                                            this._inventoryBlockedByKey.add(e),
                                            this.showInventoryError(e, `Only ${i} available`),
                                            await this.patchLineItem(e, n),
                                            this.renderElements(n),
                                            this.restoreOptimisticQuantities();
                                    }
                                } catch (e) {
                                    console.error("Failed to fetch cart section after 422:", e);
                                }
                                return this._setItemBusy(r, !1), void this._inFlightByKey.delete(e);
                            }
                        } finally {
                            this._setItemBusy(r, !1), this._inFlightByKey.delete(e);
                            const i = this._desiredQtyByKey.get(e);
                            void 0 !== i && i !== t && this._processItemUpdate(e);
                        }
                    }
                    _setItemBusy(e, t) {
                        e &&
                            [
                                e.querySelector('button[name="plus"]'),
                                e.querySelector('button[name="minus"]'),
                                e.querySelector('input[name="quantity"]'),
                            ].forEach((e) => {
                                e && (t ? e.classList.add("is-busy") : e.classList.remove("is-busy"));
                            });
                    }
                    async patchLineItem(e, t) {
                        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                        try {
                            if (!t)
                                return void console.error(
                                    `[Cart] patchLineItem: parsedSection is null/undefined for ${e}`
                                );
                            const r = t.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                            if (!r && !i)
                                return void console.warn(
                                    `[Cart] patchLineItem: Server item not found for key ${e} and no manual calc data`
                                );
                            let n = null;
                            if (r && ((n = r.querySelector(this.selectors.cartItemTotals)), !n && !i))
                                return void console.warn(`[Cart] patchLineItem: Server totals not found for key ${e}`);
                            if (i) {
                                const r = this._getCartContainers();
                                let s = null,
                                    o = null;
                                for (const { searchContainer: t, name: i } of r) {
                                    const i = t.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                                    if (i) {
                                        let e = i.querySelector(
                                                ".text-md.show-desktop " + this.selectors.priceItemSale
                                            ),
                                            t = i.querySelector(".text-md.show-desktop s");
                                        if (
                                            ((e && t) ||
                                                ((e = i.querySelector(".text-md " + this.selectors.priceItemSale)),
                                                (t = i.querySelector(".text-md s"))),
                                            !e || !t)
                                        ) {
                                            const r = i.querySelectorAll(this.selectors.priceItemSale);
                                            for (const i of r)
                                                if (!i.closest(this.selectors.cartItemTotals)) {
                                                    e = i;
                                                    const r = i.closest("dl, div");
                                                    r && (t = r.querySelector("s"));
                                                    break;
                                                }
                                        }
                                        if (e && t) {
                                            (s = e.textContent.trim()), (o = t.textContent.trim());
                                            break;
                                        }
                                    }
                                }
                                if (s && o) {
                                    const e = (e) => {
                                            const t = e.replace(/[^\d.,]/g, "");
                                            if (t.includes(",") && !t.includes("."))
                                                return parseFloat(t.replace(",", "."));
                                            if (t.includes(",") && t.includes(".")) {
                                                const e = t.split(",");
                                                if (2 === e.length && e[1].length <= 2)
                                                    return parseFloat(t.replace(/\./g, "").replace(",", "."));
                                            }
                                            return parseFloat(t.replace(/,/g, ""));
                                        },
                                        r = (e(s), e(o) * i.requestedQty),
                                        a = i.calculatedLinePrice,
                                        l = (e) => {
                                            const t = s.match(/[\d,]+\.?\d*/);
                                            if (!t) return e.toFixed(2);
                                            const i = t[0],
                                                r = s.substring(0, s.indexOf(i)),
                                                n = s.substring(s.indexOf(i) + i.length),
                                                o =
                                                    s.includes(",") &&
                                                    (!s.includes(".") || s.indexOf(",") > s.indexOf(".")),
                                                a =
                                                    i.includes(".") || i.includes(",")
                                                        ? i.split(/[.,]/)[1]?.length || 2
                                                        : 0;
                                            let l = e.toFixed(a);
                                            if (o) {
                                                l = l.replace(".", ",");
                                                const e = l.split(",");
                                                e[0].length > 3 && (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".")),
                                                    (l = e.join(","));
                                            } else {
                                                const e = l.split(".");
                                                e[0].length > 3 && (e[0] = e[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")),
                                                    (l = e.join("."));
                                            }
                                            return r + l + n;
                                        },
                                        c = `\n            <span class="text-xs show-mobile">Subtotal</span>\n            <span class="total-price">\n              <dl>\n                <dt class="visually-hidden">Regular price</dt>\n                <dd class="price-item--regular">\n                  <s class="text-xs">${l(r)}</s>\n                </dd>\n                <dt class="visually-hidden">Sale price</dt>\n                <dd class="price-item--sale">${l(a)}</dd>\n              </dl>\n            </span>\n          `;
                                    n ? (n.innerHTML = c) : (t._calculatedTotalsHTML = c);
                                } else console.warn("[Cart] Could not find per-unit prices for manual calculation");
                            }
                            if (!n && !t._calculatedTotalsHTML)
                                return void console.warn(
                                    "[Cart] patchLineItem: Cannot proceed without serverTotals or calculated HTML"
                                );
                            let s = null;
                            n ? (s = n.innerHTML) : t._calculatedTotalsHTML && (s = t._calculatedTotalsHTML),
                                this._getCartContainers().forEach((i) => {
                                    let { searchContainer: o, name: a } = i;
                                    const l = o.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                                    if (!l) return;
                                    const c = l.querySelector(this.selectors.cartItemTotals);
                                    if (c && s) {
                                        let e = null,
                                            i = null;
                                        if (n)
                                            (e = n.querySelector(this.selectors.priceItemSale)),
                                                (i = n.querySelector(this.selectors.priceItemRegular));
                                        else if (t._calculatedTotalsHTML) {
                                            const r = document.createElement("div");
                                            (r.innerHTML = t._calculatedTotalsHTML),
                                                (e = r.querySelector(this.selectors.priceItemSale)),
                                                (i = r.querySelector(this.selectors.priceItemRegular));
                                        }
                                        const r = c.querySelector(this.selectors.priceItemSale),
                                            o = r?.textContent.trim() || null,
                                            a =
                                                c.querySelector(this.selectors.priceItemRegular)?.textContent.trim() ||
                                                null,
                                            l = e?.textContent.trim() || null,
                                            d = i?.textContent.trim() || null;
                                        (o !== l || a !== d || r || e || !r) &&
                                            ((c.innerHTML = s),
                                            c.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")));
                                    } else
                                        c ||
                                            console.warn(
                                                `[Cart] patchLineItem: Current totals not found for key ${e} in ${a}`
                                            );
                                    if (r) {
                                        const e = l.querySelector(".cart-item__discounts"),
                                            t = r.querySelector(".cart-item__discounts");
                                        if (t)
                                            if (e)
                                                (e.innerHTML = t.innerHTML),
                                                    e
                                                        .querySelectorAll(".icon")
                                                        .forEach((e) => e.classList.add("loaded"));
                                            else {
                                                const e = l.querySelector(".cart-item__title");
                                                if (e) {
                                                    const i = t.cloneNode(!0);
                                                    e.appendChild(i),
                                                        i
                                                            .querySelectorAll(".icon")
                                                            .forEach((e) => e.classList.add("loaded"));
                                                }
                                            }
                                        else e && e.remove();
                                    }
                                });
                        } catch (t) {
                            console.error(`[Cart] Error in patchLineItem for ${e}:`, t),
                                console.error("[Cart] Error stack:", t.stack);
                        }
                    }
                    restoreOptimisticQuantities() {
                        this._desiredQtyByKey.forEach((e, t) => {
                            this._inventoryBlockedByKey.has(t) ||
                                this._getCartContainers().forEach((i) => {
                                    let { searchContainer: r } = i;
                                    const n = r.querySelector(`${this.selectors.cartItem}[data-item-id="${t}"]`);
                                    if (!n) return;
                                    const s = n.querySelector('input[name="quantity"]');
                                    if (!s) return;
                                    const o = this._maxQtyByKey.get(t),
                                        a = void 0 !== o ? Math.min(e, o) : e;
                                    (parseInt(s.value) || 1) !== a && (s.value = a);
                                });
                        });
                    }
                    showInventoryError(e, t) {
                        const i = this._errorTimeoutByKey.get(e);
                        i && clearTimeout(i),
                            this._getCartContainers().forEach((i) => {
                                let { searchContainer: r } = i;
                                const n = r.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                                if (!n) return;
                                const s = n.querySelector(".cart-item__error");
                                s && ((s.textContent = t), (s.style.display = "block"));
                            });
                        const r = setTimeout(() => {
                            const i = this._desiredQtyByKey.get(e),
                                r = this._maxQtyByKey.get(e);
                            void 0 === i || void 0 === r || i <= r
                                ? this.clearInventoryError(e)
                                : this.showInventoryError(e, t);
                        }, 4e3);
                        this._errorTimeoutByKey.set(e, r);
                    }
                    clearInventoryError(e) {
                        const t = this._errorTimeoutByKey.get(e);
                        t && (clearTimeout(t), this._errorTimeoutByKey.delete(e)),
                            this._getCartContainers().forEach((t) => {
                                let { searchContainer: i } = t;
                                const r = i.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                                if (!r) return;
                                const n = r.querySelector(".cart-item__error");
                                n && ((n.textContent = ""), (n.style.display = "none"));
                            });
                    }
                    _removeDeleteClass(e) {
                        this._getCartContainers().forEach((t) => {
                            let { searchContainer: i } = t;
                            const r = i.querySelector(`${this.selectors.cartItem}[data-item-id="${e}"]`);
                            r && r.classList.remove("is-deleting");
                        });
                    }
                    _animateItemRemoval(e) {
                        return new Promise((t) => {
                            if (!e) return void t();
                            if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
                                return e.remove(), void t();
                            const i = e.offsetHeight;
                            (e.style.height = `${i}px`),
                                (e.style.overflow = "hidden"),
                                e.setAttribute("aria-live", "polite"),
                                e.setAttribute("aria-atomic", "true"),
                                e.offsetHeight,
                                requestAnimationFrame(() => {
                                    e.classList.add("cart-item--removing"),
                                        setTimeout(() => {
                                            e.remove(), t();
                                        }, 300);
                                });
                        });
                    }
                    removeEventListeners(e) {
                        const t = e.querySelector(".cart-item-delete, .cart-item__remove"),
                            i = e.querySelector('button[name="plus"]'),
                            r = e.querySelector('button[name="minus"]'),
                            n = e.querySelector('input[name="quantity"]');
                        t && t._deleteHandler && t.removeEventListener("click", t._deleteHandler),
                            i && i._clickHandler && i.removeEventListener("click", i._clickHandler),
                            r && r._clickHandler && r.removeEventListener("click", r._clickHandler),
                            n &&
                                (n._changeHandler && n.removeEventListener("change", n._changeHandler),
                                n._keypressHandler && n.removeEventListener("keypress", n._keypressHandler));
                    }
                    manageState(e) {
                        this.removeEventListeners(e);
                        const t = e.getAttribute("data-item-id"),
                            i = e.getAttribute("data-variant-id"),
                            r = e.getAttribute("data-max-qty");
                        if (r && !this._maxQtyByKey.has(t)) {
                            const e = parseInt(r);
                            !isNaN(e) && e > 0 && this._maxQtyByKey.set(t, e);
                        }
                        const n = e.querySelector(".cart-item-delete, .cart-item__remove");
                        if (n) {
                            const e = async () => {
                                if (this._deletingByKey.has(t))
                                    this.debugMode &&
                                        console.log(
                                            `[Cart] Delete already in progress for ${t}, ignoring duplicate request`
                                        );
                                else
                                    try {
                                        this._deletingByKey.add(t),
                                            this._getCartContainers().forEach((e) => {
                                                let { searchContainer: i } = e;
                                                const r = i.querySelector(
                                                    `${this.selectors.cartItem}[data-item-id="${t}"]`
                                                );
                                                r && r.classList.add("is-deleting");
                                            }),
                                            console.log(`[Cart] Starting delete for ${t}`),
                                            console.log(
                                                `[Cart] Fetching current cart state to find correct line number for ${t}`
                                            );
                                        const e = await fetch("/cart.js"),
                                            r = (await e.json()).items.findIndex((e) => e.key === t);
                                        if (-1 === r)
                                            return (
                                                console.warn(
                                                    `[Cart] Item ${t} not found in current cart, may already be deleted`
                                                ),
                                                void this._getCartContainers().forEach((e) => {
                                                    let { searchContainer: i } = e;
                                                    const r = i.querySelector(
                                                        `${this.selectors.cartItem}[data-item-id="${t}"]`
                                                    );
                                                    r && r.remove();
                                                })
                                            );
                                        const n = r + 1;
                                        let s;
                                        console.log(`[Cart] Item ${t} is at line ${n} (was stored as line ${i})`);
                                        try {
                                            (s = await this.changeCartItem({ id: n, quantity: 0 })),
                                                console.log("[Cart] Delete request successful, response:", s);
                                        } catch (e) {
                                            if (
                                                (console.error(`[Cart] changeCartItem failed for ${t}:`, e),
                                                429 !== e.status)
                                            )
                                                return 422 === e.status
                                                    ? (console.error(
                                                          `[Cart] Server validation error (422) for ${t} - item NOT deleted, keeping in cart`
                                                      ),
                                                      void this._removeDeleteClass(t))
                                                    : (console.error(
                                                          `[Cart] Unexpected error for ${t} - item may still be in cart`
                                                      ),
                                                      void this._removeDeleteClass(t));
                                            console.warn(
                                                `[Cart] Rate limited (429) for ${t}, waiting 500ms then retrying...`
                                            ),
                                                await new Promise((e) => setTimeout(e, 500));
                                            try {
                                                (s = await this.changeCartItem({ id: i, quantity: 0 })),
                                                    this.debugMode &&
                                                        console.log(
                                                            `[Cart] Retry after rate limit successful for ${t}`
                                                        );
                                            } catch (e) {
                                                return (
                                                    console.error(`[Cart] Retry failed for ${t}:`, e),
                                                    void this._removeDeleteClass(t)
                                                );
                                            }
                                        }
                                        if (s) {
                                            const e = 0 === s.item_count;
                                            this.debugMode &&
                                                console.log(
                                                    `[Cart] Removing item ${t} from all containers (${s.item_count} items remain, isLastItem: ${e})`
                                                );
                                            const i = this._getCartContainers();
                                            this.debugMode &&
                                                console.log(`[Cart] Found ${i.length} cart containers to update`);
                                            const r = i.map((e) => {
                                                let { searchContainer: i, name: r } = e;
                                                const n = i.querySelector(
                                                    `${this.selectors.cartItem}[data-item-id="${t}"]`
                                                );
                                                return n
                                                    ? (this.debugMode &&
                                                          console.log(`[Cart] Removing item ${t} from ${r}`),
                                                      this._animateItemRemoval(n))
                                                    : (this.debugMode &&
                                                          console.log(`[Cart] Item ${t} not found in ${r}`),
                                                      Promise.resolve());
                                            });
                                            await Promise.all(r),
                                                this._desiredQtyByKey.delete(t),
                                                this._inFlightByKey.delete(t),
                                                this._inventoryBlockedByKey.delete(t),
                                                this._maxQtyByKey.delete(t),
                                                this._versionByKey.delete(t);
                                            const n = this._errorTimeoutByKey.get(t);
                                            n && (clearTimeout(n), this._errorTimeoutByKey.delete(t)),
                                                e &&
                                                    this.debugMode &&
                                                    console.log(
                                                        "[Cart] Last item removed, empty state should be visible"
                                                    );
                                        } else console.error("[Cart] Delete operation failed - no response received");
                                    } catch (e) {
                                        console.error(`[Cart] Error deleting item ${t}:`, e);
                                    } finally {
                                        this._deletingByKey.delete(t),
                                            this.debugMode && console.log(`[Cart] Delete operation completed for ${t}`);
                                    }
                            };
                            (n._deleteHandler = e), n.addEventListener("click", e);
                        }
                        if (!e.querySelector('input[name="quantity"]')) return;
                        const s = e.querySelector('button[name="plus"]'),
                            o = e.querySelector('button[name="minus"]'),
                            a = e.querySelector('input[name="quantity"]'),
                            l = () => {
                                const e = parseInt(a.value) || 1,
                                    i = this._maxQtyByKey.get(t),
                                    r = void 0 !== i ? Math.min(i, e + 1) : e + 1;
                                r !== e || void 0 === i
                                    ? ((a.value = r), this.requestQuantityUpdate(t, r))
                                    : this.showInventoryError(t, `Only ${i} available`);
                            },
                            c = () => {
                                const e = parseInt(a.value) || 1,
                                    i = Math.max(1, e - 1);
                                i !== e && ((a.value = i), this.requestQuantityUpdate(t, i));
                            },
                            d = (e) => {
                                const i = parseInt(e.target.value);
                                let r = isNaN(i) || i < 1 ? 1 : i;
                                const n = parseInt(a.value) || 1,
                                    s = this._maxQtyByKey.get(t);
                                void 0 !== s && r > s && ((r = s), this.showInventoryError(t, `Only ${s} available`)),
                                    (r === n && a.value === String(r)) ||
                                        ((a.value = r), this.requestQuantityUpdate(t, r));
                            },
                            u = (e) => {
                                ((8 !== e.which && 0 !== e.which && e.which < 48) || e.which > 57) &&
                                    e.preventDefault();
                            };
                        s && ((s._clickHandler = l), s.addEventListener("click", l)),
                            o && ((o._clickHandler = c), o.addEventListener("click", c)),
                            (a._changeHandler = d),
                            a.addEventListener("change", d),
                            (a._keypressHandler = u),
                            a.addEventListener("keypress", u);
                    }
                    async changeCartItem(e) {
                        const t = {
                            ...(0, r.Q2)(),
                            body: JSON.stringify({ line: +e.id, quantity: e.quantity, sections: "main-cart" }),
                        };
                        return fetch(`${routes.cartChange}`, t)
                            .then((e) => {
                                if (!e.ok && 429 === e.status) {
                                    const e = new Error("Rate limited");
                                    throw ((e.status = 429), e);
                                }
                                if (!e.ok && 422 === e.status) {
                                    const e = new Error("Item already deleted or invalid");
                                    throw ((e.status = 422), e);
                                }
                                if (!e.ok) throw new Error(`HTTP error! status: ${e.status}`);
                                return e.json();
                            })
                            .then(async (t) => {
                                const i = async (i, r) => {
                                    let n = this.parser.parseFromString(i, "text/html");
                                    if (r && t.item_count > 0) {
                                        const t = n.querySelector(`.cart-item[data-item-id="${r}"]`),
                                            i = t && t.querySelector(".cart-item__totals"),
                                            s = i && i.querySelector(".price-item--sale"),
                                            o = document.querySelector(`.cart-item[data-item-id="${r}"]`),
                                            a = o && o.querySelector(".cart-item__totals"),
                                            l = a && a.querySelector(".price-item--sale");
                                        if (s || l) {
                                            const i = e.quantity,
                                                s = t && t.querySelector('input[name="quantity"]'),
                                                o = (s && parseInt(s.value)) || 1;
                                            if (t && o === i);
                                            else {
                                                const e = this._getCartContainers();
                                                let t = null;
                                                for (const { searchContainer: i } of e) {
                                                    const e = i.querySelector(
                                                        `${this.selectors.cartItem}[data-item-id="${r}"]`
                                                    );
                                                    if (e) {
                                                        let i = e.querySelector(
                                                            ".text-md.show-desktop " + this.selectors.priceItemSale
                                                        );
                                                        if (
                                                            (i ||
                                                                (i = e.querySelector(
                                                                    ".text-md " + this.selectors.priceItemSale
                                                                )),
                                                            !i)
                                                        ) {
                                                            const t = e.querySelectorAll(this.selectors.priceItemSale);
                                                            for (const e of t)
                                                                if (!e.closest(this.selectors.cartItemTotals)) {
                                                                    i = e;
                                                                    break;
                                                                }
                                                        }
                                                        if (i) {
                                                            const e = i.textContent.trim().replace(/[^\d.,]/g, "");
                                                            if (e.includes(",") && !e.includes("."))
                                                                t = parseFloat(e.replace(",", "."));
                                                            else if (e.includes(",") && e.includes(".")) {
                                                                const i = e.split(",");
                                                                t =
                                                                    2 === i.length && i[1].length <= 2
                                                                        ? parseFloat(
                                                                              e.replace(/\./g, "").replace(",", ".")
                                                                          )
                                                                        : parseFloat(e.replace(/,/g, ""));
                                                            } else t = parseFloat(e.replace(/,/g, ""));
                                                            if (!isNaN(t)) break;
                                                        }
                                                    }
                                                }
                                                if (null !== t) {
                                                    const e = t * i;
                                                    (n._needsManualPriceCalc = !0),
                                                        (n._calculatedLinePrice = e),
                                                        (n._requestedQty = i);
                                                }
                                            }
                                        }
                                    }
                                    if (0 === t.item_count) {
                                        console.log("[Cart] Cart is empty, rendering empty state");
                                        const e = document.querySelector(this.mainCartSelector);
                                        if (e) {
                                            const t = n.querySelector(this.mainCartSelector);
                                            t
                                                ? (console.log("[Cart] Updating main cart with empty state HTML"),
                                                  (e.innerHTML = t.innerHTML))
                                                : console.warn(
                                                      `[Cart] Could not find main cart selector "${this.mainCartSelector}" in parsed content`
                                                  );
                                        } else console.log("[Cart] No main cart element found on page");
                                        this.renderElements(n);
                                    } else if ((this.renderElements(n), r)) {
                                        const e = n._needsManualPriceCalc
                                            ? {
                                                  calculatedLinePrice: n._calculatedLinePrice,
                                                  requestedQty: n._requestedQty,
                                              }
                                            : null;
                                        await this.patchLineItem(r, n, e);
                                    }
                                    this.restoreOptimisticQuantities();
                                };
                                if (t.sections && null !== t.sections["main-cart"])
                                    await i(t.sections["main-cart"], e.itemKey);
                                else {
                                    const t = `${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`;
                                    await fetch(t)
                                        .then((e) => e.text())
                                        .then(async (t) => {
                                            await i(t, e.itemKey);
                                        });
                                }
                                const r = `${window.location.pathname}?section_id=navigation-main`;
                                return fetch(r)
                                    .then((e) => e.text())
                                    .then((e) => {
                                        if ((this.parser.parseFromString(e, "text/html"), 0 === t.item_count)) {
                                            console.log(
                                                "[Cart] Cart is now empty, manually updating mini-cart to empty state"
                                            );
                                            const e = document.querySelector("#mini-cart");
                                            if (e) {
                                                const t = e.querySelector(".cart-items-container");
                                                t &&
                                                    (console.log("[Cart] Hiding cart-items-container"),
                                                    (t.style.display = "none"),
                                                    t.remove());
                                                let i = e.querySelector(".mini-cart--empty");
                                                if (i)
                                                    console.log(
                                                        "[Cart] Found existing mini-cart--empty, making it visible"
                                                    ),
                                                        (i.style.display = "block");
                                                else {
                                                    console.log(
                                                        "[Cart] No mini-cart--empty found, checking mini-cart__content"
                                                    );
                                                    const t = e.querySelector(".mini-cart__content");
                                                    t &&
                                                        ((i = t.querySelector(".mini-cart--empty")),
                                                        i &&
                                                            (console.log(
                                                                "[Cart] Found mini-cart--empty in content, making visible"
                                                            ),
                                                            (i.style.display = "block")));
                                                }
                                                e.querySelectorAll(".cart-count").forEach((e) => {
                                                    e.textContent = "0";
                                                }),
                                                    e.querySelectorAll(".cart-total-price").forEach((e) => {
                                                        e.textContent = "$0.00";
                                                    });
                                                const r = e.querySelector("#checkout");
                                                r && (r.disabled = !0);
                                                const n = e.querySelector(".cart-summary__free-shipping");
                                                n &&
                                                    ((n.style.display = "none"),
                                                    console.log(
                                                        "[Cart] Hidden free shipping calculator for empty cart"
                                                    )),
                                                    console.log("[Cart] ✓ Mini-cart manually updated to empty state");
                                            } else console.log("[Cart] No mini-cart element found on page");
                                        }
                                        return t;
                                    });
                            })
                            .catch((e) => {
                                throw (console.error(e), e);
                            });
                    }
                    renderElements(e) {
                        this.selectorsToUpdate.forEach((t) => {
                            try {
                                const i = document.querySelectorAll(t),
                                    r = e.querySelector(t);
                                i.length &&
                                    r &&
                                    (r.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                    i.forEach((e) => {
                                        e.innerHTML = r.innerHTML;
                                    }));
                            } catch (e) {
                                console.error(`Error updating ${t}`, e);
                            }
                        });
                        const t = e.querySelector(".cart-total-price");
                        if (t) {
                            const e = [],
                                i = document.querySelector(this.mainCartSelector);
                            i && e.push(i),
                                this.miniCart && e.push(this.miniCart),
                                e.forEach((e) => {
                                    const i = e.querySelector(".cart-total-price");
                                    i && (i.innerHTML = t.innerHTML);
                                });
                        }
                        const i = e.querySelector(".cart-count");
                        document
                            .querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count")
                            .forEach((e) => {
                                i
                                    ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"),
                                      (e.textContent = i.textContent))
                                    : e.classList.add("visually-hidden");
                            }),
                            document.querySelector("#cart-open-block .icon").classList.add("loaded");
                    }
                    renderItems(e) {
                        this.renderElements(e);
                        const t = Array.from(document.querySelectorAll(this.itemsContainersSelector)),
                            i = e.querySelector(this.itemsContainersSelector);
                        t.forEach((e) => {
                            e && e.replaceWith(i.cloneNode(!0));
                        }),
                            document.querySelectorAll(".cart-item").forEach((e) => {
                                e.querySelectorAll(".icon").forEach((e) => e.classList.add("loaded")),
                                    this.manageState(e);
                            });
                    }
                    updateMiniCart(e) {
                        return fetch(`${window.location.pathname}?section_id=main-cart&_ts=${Date.now()}`)
                            .then((e) => e.text())
                            .then((t) => {
                                this.renderItems(new DOMParser().parseFromString(t, "text/html")),
                                    e && "mini-cart" === cartStrings.uxCart && this.miniCart && this.miniCart.open();
                            })
                            .catch((e) => {
                                console.error("Error updating mini cart:", e);
                            });
                    }
                })();
                (window.cartService = n),
                    (window.updateMiniCart = function () {
                        return n.updateMiniCart(...arguments);
                    }),
                    (t.Z = n),
                    customElements.get("cart-note") ||
                        customElements.define(
                            "cart-note",
                            class extends HTMLElement {
                                constructor() {
                                    super(),
                                        this.querySelector("textarea").addEventListener(
                                            "change",
                                            (0, r.Ds)((e) => {
                                                const t = JSON.stringify({ note: e.target.value });
                                                fetch(`${routes.cartUpdate}`, { ...(0, r.Q2)(), body: t });
                                            }, 300)
                                        );
                                }
                            }
                        );
            },
            1717: function (e, t, i) {
                "use strict";
                i.d(t, {
                    f: function () {
                        return s;
                    },
                });
                var r = i(6072),
                    n = i(4487);
                const s = () => {
                    const e = document.querySelectorAll('form[data-type="add-to-cart-form"]'),
                        t = document.getElementById("main-cart"),
                        i = document.getElementById("mini-cart"),
                        s = document.querySelector("body");
                    e.length &&
                        e.forEach((e) =>
                            e.addEventListener("submit", (o) => {
                                o.preventDefault(),
                                    o.stopPropagation(),
                                    o.target.querySelector(
                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                    ) &&
                                        (o.target.querySelector(
                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                        ).textContent = `${cartStrings.addingToCart}`);
                                const a = o.target.querySelector('button[type="submit"]'),
                                    l = a.querySelector("span.cart-icon"),
                                    c = a.querySelector("svg.loading-icon");
                                s.classList.remove("added-to-cart"),
                                    a.classList.add("added"),
                                    (l.style.display = "none"),
                                    (c.style.display = "block");
                                const d = (0, r.Q2)("javascript");
                                (d.headers["X-Requested-With"] = "XMLHttpRequest"), delete d.headers["Content-Type"];
                                const u = new FormData(e);
                                u.append("sections", "main-cart"),
                                    (d.body = u),
                                    fetch(`${routes.cartAdd}`, d)
                                        .then((e) => e.json())
                                        .then(async (e) => {
                                            if (e.status) {
                                                if (
                                                    (n.Z.updateMiniCart(!0),
                                                    (l.style.display = "inline-flex"),
                                                    (c.style.display = "none"),
                                                    o.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (o.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addToCart}`),
                                                    "object" == typeof e.description)
                                                )
                                                    return Object.entries(e.description).forEach((e) => {
                                                        let [t, i] = e;
                                                        const r = `${i.join(", ")}`;
                                                        o.target.querySelector(".main-product__error").innerHTML =
                                                            '<span class="icon loaded">error</span><p>' + r + "</p>";
                                                    });
                                                o.target.querySelector(".main-product__error").innerHTML =
                                                    '<span class="icon loaded">error</span><p>' +
                                                    e.description +
                                                    "</p>";
                                            } else {
                                                if ("cart" === cartStrings.uxCart)
                                                    return void (window.location.href = window.routes.cart);
                                                if (
                                                    ((o.target.querySelector(".main-product__error").innerHTML = ""),
                                                    t && t.classList.add("added"),
                                                    e.sections && null !== e.sections["main-cart"])
                                                )
                                                    n.Z.renderItems(
                                                        new DOMParser().parseFromString(
                                                            e.sections["main-cart"],
                                                            "text/html"
                                                        )
                                                    );
                                                else {
                                                    const e = `${window.location.pathname}?section_id=main-cart`;
                                                    fetch(e)
                                                        .then((e) => e.text())
                                                        .then((e) => {
                                                            n.Z.renderItems(
                                                                new DOMParser().parseFromString(e, "text/html")
                                                            );
                                                        });
                                                }
                                                "mini-cart" === cartStrings.uxCart && i && i.open(),
                                                    o.target.querySelector(
                                                        'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                    ) &&
                                                        (o.target.querySelector(
                                                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                                                        ).textContent = `${cartStrings.addedToCart}`),
                                                    a.classList.remove("added"),
                                                    a.classList.add("successful"),
                                                    (l.style.display = "flex"),
                                                    (c.style.display = "none"),
                                                    s.classList.add("added-to-cart");
                                            }
                                        })
                                        .catch((e) => {
                                            console.error("Error:", e);
                                        });
                            })
                        );
                };
            },
            1434: function (e, t) {
                "use strict";
                const i = "above-overlay",
                    r = new Set();
                t.Z = class {
                    isClosingTimer = null;
                    attachedElements = new Set();
                    constructor() {
                        let e =
                            arguments.length > 0 && void 0 !== arguments[0]
                                ? arguments[0]
                                : document.querySelector("#main-content");
                        (this.container = e),
                            (this.overlay = document.createElement("div")),
                            (this.overlay.innerHTML = "&nbsp;"),
                            this.overlay.classList.add("overlay"),
                            this.overlay.addEventListener("transitionend", (e) => {
                                "opacity" !== e.propertyName ||
                                    this.isOpen ||
                                    (this.attachedElements &&
                                        this.attachedElements.size &&
                                        this.attachedElements.forEach((e) => {
                                            this.detachElement(e);
                                        }),
                                    this.afterClosed && (this.afterClosed(), (this.afterClosed = null)),
                                    this.detachOverlay()),
                                    "opacity" === e.propertyName &&
                                        this.isOpen &&
                                        this.afterOpened &&
                                        (this.afterOpened(), (this.afterOpened = null));
                            }),
                            r.add(this);
                    }
                    attachOverlay() {
                        this.container.appendChild(this.overlay);
                    }
                    detachOverlay() {
                        this.container.removeChild(this.overlay);
                    }
                    async open() {
                        let {
                            attachElements: e,
                            afterOpened: t,
                            beforeOpened: r,
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        await this.attachOverlay(),
                            this.isClosingTimer && (clearTimeout(this.isClosingTimer), (this.isClosingTimer = null)),
                            r && r(),
                            e &&
                                (e.forEach((e) => {
                                    this.attachedElements.add(e);
                                }),
                                this.attachedElements.forEach((e) => {
                                    e.classList.add(i);
                                })),
                            requestAnimationFrame(() => {
                                this.overlay.classList.add("open");
                            }),
                            t && (this.afterOpened = t);
                    }
                    close() {
                        let {
                            delay: e,
                            beforeClosed: t,
                            afterClosed: i,
                        } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t && t(), (this.afterClosed = i);
                        const r = () => {
                            requestAnimationFrame(() => {
                                this.overlay.classList.remove("open");
                            });
                        };
                        e ? (this.isClosingTimer = setTimeout(r, e)) : r();
                    }
                    detachElement(e) {
                        this.attachedElements.has(e) &&
                            e.classList.contains(i) &&
                            (e.classList.remove(i), this.attachedElements.delete(e));
                    }
                    get isOpen() {
                        return this.overlay.classList.contains("open");
                    }
                    onClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.addEventListener("click", e);
                    }
                    removeOnClick() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e && this.overlay.removeEventListener("click", e);
                    }
                    onHover() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
                        e &&
                            this.overlay.addEventListener("mouseover", (t) => {
                                this.isOpen && e(t);
                            });
                    }
                };
            },
            3643: function (e, t, i) {
                "use strict";
                i.d(t, {
                    M: function () {
                        return r;
                    },
                }),
                    (0, i(2994).z2)();
                class r {
                    constructor() {
                        this.initializeSwipers(),
                            Shopify.designMode &&
                                document.addEventListener("shopify:section:load", () => this.initializeSwipers());
                    }
                    initializeSwipers() {
                        document.querySelectorAll("swiper-container").forEach((e) => {
                            e.dataset.mobileSlidesPerView;
                            const t =
                                    (e.dataset.desktopSlidesPerView,
                                    "0" !== e.dataset.tabletSlidesPerView &&
                                        e.dataset.tabletSlidesPerView &&
                                        e.dataset.tabletSlidesPerView,
                                    "true" === e.dataset.textPagination),
                                i = Number(e.dataset.spaceBetweenMobile) || 16,
                                r = Number(e.dataset.spaceBetweenTablet) || 32,
                                n = Number(e.dataset.spaceBetweenDesktop) || 32,
                                s = e.dataset.mobileLayout || "slider",
                                o = e.dataset.desktopLayout || "slider",
                                a = window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
                                l = window.matchMedia("(min-width: 1024px)"),
                                c = () => {
                                    e.querySelectorAll("video").forEach((e) => {
                                        e.classList.contains("section__wrapper-background") || e.pause();
                                    }),
                                        Array.from(e.querySelectorAll("swiper-slide"))
                                            .filter((e) => e.classList.contains("swiper-slide-visible"))
                                            .forEach((e) => {
                                                const t = e.querySelector("video");
                                                t && t.hasAttribute("autoplay") && t.play();
                                            });
                                },
                                d = () => {
                                    const t = e.closest(".slideshow-text-controls__wrapper");
                                    if (!t) return;
                                    const i = e.swiper.slides[e.swiper.realIndex];
                                    if (!i) return;
                                    const r = i.getAttribute("data-slide");
                                    t.querySelectorAll(".slideshow-text-controls__item").forEach((e) => {
                                        e.classList.toggle("active", e.getAttribute("data-slide") === r);
                                    });
                                },
                                u = () => {
                                    if ((l.matches && "slider" === o) || (a.matches && "slider" === s))
                                        if (!e.swiper || e.swiper.destroyed) {
                                            const s = parseFloat(e.dataset.mobileSlidesPerView) || "auto",
                                                o =
                                                    "0" !== e.dataset.tabletSlidesPerView &&
                                                    e.dataset.tabletSlidesPerView
                                                        ? parseFloat(e.dataset.tabletSlidesPerView)
                                                        : s,
                                                a = parseFloat(e.dataset.desktopSlidesPerView) || "auto",
                                                l = {
                                                    ...(e.parentElement?.classList.contains("card__image")
                                                        ? { virtual: { enabled: !0 }, nested: !0 }
                                                        : {}),
                                                    breakpoints: {
                                                        0: { slidesPerView: s, spaceBetween: parseInt(i) },
                                                        768: { slidesPerView: o, spaceBetween: parseInt(r) },
                                                        1024: { slidesPerView: a, spaceBetween: parseInt(n) },
                                                    },
                                                };
                                            Object.assign(e, l),
                                                e.addEventListener("swiperafterinit", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t && t.classList.add("slider-enabled"),
                                                        setTimeout(() => {
                                                            if (!e.swiper) return;
                                                            const t = e.swiper?.slides?.length || 0,
                                                                i = t < s ? t : s,
                                                                r = t < o ? t : o,
                                                                n = t < a ? t : a;
                                                            e.swiper &&
                                                                e.swiper.params &&
                                                                e.swiper.params.breakpoints &&
                                                                ((e.swiper.currentBreakpoint = !1),
                                                                (e.swiper.params.breakpoints[0].slidesPerView = i),
                                                                (e.swiper.params.breakpoints[768].slidesPerView = r),
                                                                (e.swiper.params.breakpoints[992].slidesPerView = n),
                                                                e.swiper.update(),
                                                                e.swiper.slideTo(0, 0, !1)),
                                                                c(),
                                                                (() => {
                                                                    const t = e
                                                                        .closest(".main-product__media-wrapper")
                                                                        ?.querySelector(".swiper-thumbnails .swiper");
                                                                    t &&
                                                                        (Object.assign(t, {
                                                                            direction: "vertical",
                                                                            slidesPerView: "auto",
                                                                            spaceBetween: 8,
                                                                            watchSlidesProgress: !0,
                                                                            navigation: {
                                                                                nextEl: ".swiper-button-thumbs-next",
                                                                                prevEl: ".swiper-button-thumbs-prev",
                                                                            },
                                                                            breakpoints: {
                                                                                0: {
                                                                                    direction: "horizontal",
                                                                                    slidesPerView: 4,
                                                                                },
                                                                                768: {
                                                                                    direction: "vertical",
                                                                                    slidesPerView: "auto",
                                                                                },
                                                                            },
                                                                        }),
                                                                        t.initialize());
                                                                })();
                                                        }, 0);
                                                }),
                                                e.addEventListener("swiperslidechange", () => {
                                                    c(), d();
                                                }),
                                                e.addEventListener("swiperdestroy", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t && t.classList.remove("slider-enabled");
                                                }),
                                                e.addEventListener("swiperlock", () => {
                                                    const t = e.closest(".shopify-section");
                                                    t &&
                                                        !t.classList.contains("recommended-products") &&
                                                        setTimeout(() => {
                                                            t.querySelectorAll(".grid-content__slider-nav").forEach(
                                                                (e) => {
                                                                    e.style.display = "none";
                                                                }
                                                            );
                                                        }, 1);
                                                }),
                                                e.initialize(),
                                                t &&
                                                    ((() => {
                                                        if (!t) return;
                                                        const i = e.closest(".slideshow-text-controls__wrapper");
                                                        i &&
                                                            i
                                                                .querySelectorAll(".slideshow-text-controls__item")
                                                                .forEach((t) => {
                                                                    t.addEventListener("click", () => {
                                                                        const i = t.getAttribute("data-slide"),
                                                                            r = Array.from(e.swiper.slides).findIndex(
                                                                                (e) =>
                                                                                    e.getAttribute("data-slide") === i
                                                                            );
                                                                        -1 !== r && e.swiper.slideTo(r);
                                                                    });
                                                                });
                                                    })(),
                                                    d());
                                        } else e.swiper.update();
                                    else if ((Object.assign(e), e.initialize(), e.swiper)) {
                                        e.swiper.destroy(!0, !0);
                                        const t = e.closest(".shopify-section");
                                        t && t.classList.remove("slider-enabled");
                                    }
                                };
                            window.addEventListener("resize", u), u();
                        });
                    }
                }
                new r();
            },
            6072: function (e, t, i) {
                "use strict";
                i.d(t, {
                    Ds: function () {
                        return c;
                    },
                    Q2: function () {
                        return r;
                    },
                    Sw: function () {
                        return m;
                    },
                    X5: function () {
                        return d;
                    },
                    g: function () {
                        return s;
                    },
                    gp: function () {
                        return l;
                    },
                    hO: function () {
                        return n;
                    },
                    zx: function () {
                        return h;
                    },
                });
                const r = function () {
                        return {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`,
                            },
                        };
                    },
                    n = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        const t = window.innerWidth - document.body.offsetWidth,
                            i = document.getElementById("nav-wrapper");
                        e
                            ? (document.body.classList.add("no-scroll"),
                              (document.body.style.paddingRight = t + "px"),
                              (i.style.paddingRight = t + "px"))
                            : (document.body.classList.remove("no-scroll"),
                              (document.body.style.paddingRight = "0px"),
                              (i.style.paddingRight = "0px"));
                    },
                    s = function () {
                        let e = arguments.length > 1 ? arguments[1] : void 0;
                        arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                            ? document.body.classList.add(`no-scroll--${e}`)
                            : document.body.classList.remove(`no-scroll--${e}`);
                    };
                let o = () => {};
                const a = (e) => {
                        "Escape" === e.key && (o(), window.removeEventListener("keydown", a));
                    },
                    l = function () {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (o = t),
                            e && window.addEventListener("keydown", a),
                            e || window.removeEventListener("keydown", a);
                    };
                function c(e, t) {
                    const i = this;
                    let r;
                    return function () {
                        for (var n = arguments.length, s = new Array(n), o = 0; o < n; o++) s[o] = arguments[o];
                        clearTimeout(r),
                            (r = setTimeout(function () {
                                return e.apply(i, s);
                            }, t));
                    };
                }
                function d(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const i = document.getElementById("nav-wrapper"),
                        r = document.querySelector(".header").getAttribute("data-ux-position"),
                        n = e.getBoundingClientRect().top;
                    window.scrollTo({
                        top:
                            "off" !== r
                                ? n + window.scrollY - t + parseFloat(i.style.marginTop)
                                : n + window.scrollY - t,
                        behavior: "smooth",
                    });
                }
                document.querySelectorAll(".local-scroll").forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        d(document.querySelector(t));
                    });
                });
                const u = {};
                function h(e) {
                    document.removeEventListener("focusin", u.focusin),
                        document.removeEventListener("focusout", u.focusout),
                        document.removeEventListener("keydown", u.keydown),
                        e && e.focus();
                }
                const m = () => {
                    const e = document.querySelector(".grid-archive__content");
                    document.querySelector(".grid-archive__subnav .cols") &&
                        (document.querySelectorAll(".view-icon-desktop").forEach((t) => {
                            t.onclick = function () {
                                document.querySelectorAll(".view-icon-desktop").forEach((e) => {
                                    e.classList.remove("active");
                                }),
                                    this.classList.add("active"),
                                    localStorage.setItem("columns-desktop", t.dataset.columns),
                                    4 == t.dataset.columns
                                        ? (e.classList.remove("grid-archive__content--three-column"),
                                          e.classList.add("grid-archive__content--four-column"))
                                        : (e.classList.add("grid-archive__content--three-column"),
                                          e.classList.remove("grid-archive__content--four-column"));
                            };
                        }),
                        document.querySelectorAll(".view-icon-mobile").forEach((t) => {
                            t.onclick = function () {
                                document.querySelectorAll(".view-icon-mobile").forEach((e) => {
                                    e.classList.remove("active");
                                }),
                                    this.classList.add("active"),
                                    localStorage.setItem("columns-mobile", t.dataset.columns),
                                    1 == t.dataset.columns
                                        ? (e.classList.remove("grid-archive__content--two-column"),
                                          e.classList.add("grid-archive__content--one-column"))
                                        : (e.classList.add("grid-archive__content--two-column"),
                                          e.classList.remove("grid-archive__content--one-column"));
                            };
                        }),
                        4 == localStorage.getItem("columns-desktop") &&
                            (e.classList.remove("grid-archive__content--three-column"),
                            e.classList.add("grid-archive__content--four-column"),
                            document.querySelector(".three-col").classList.remove("active"),
                            document.querySelector(".four-col").classList.add("active")),
                        1 == localStorage.getItem("columns-mobile") &&
                            (e.classList.remove("grid-archive__content--two-column"),
                            e.classList.add("grid-archive__content--one-column"),
                            document.querySelector(".two-col").classList.remove("active"),
                            document.querySelector(".one-col").classList.add("active")));
                };
            },
            5122: function () {},
        },
        i = {};
    function r(e) {
        var n = i[e];
        if (void 0 !== n) return n.exports;
        var s = (i[e] = { exports: {} });
        return t[e](s, s.exports, r), s.exports;
    }
    (r.m = t),
        (e = []),
        (r.O = function (t, i, n, s) {
            if (!i) {
                var o = 1 / 0;
                for (d = 0; d < e.length; d++) {
                    (i = e[d][0]), (n = e[d][1]), (s = e[d][2]);
                    for (var a = !0, l = 0; l < i.length; l++)
                        (!1 & s || o >= s) &&
                        Object.keys(r.O).every(function (e) {
                            return r.O[e](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((a = !1), s < o && (o = s));
                    if (a) {
                        e.splice(d--, 1);
                        var c = n();
                        void 0 !== c && (t = c);
                    }
                }
                return t;
            }
            s = s || 0;
            for (var d = e.length; d > 0 && e[d - 1][2] > s; d--) e[d] = e[d - 1];
            e[d] = [i, n, s];
        }),
        (r.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return r.d(t, { a: t }), t;
        }),
        (r.d = function (e, t) {
            for (var i in t) r.o(t, i) && !r.o(e, i) && Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
        }),
        (r.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (r.j = 6955),
        (function () {
            var e = { 6955: 0, 7658: 0, 7954: 0, 8973: 0, 9217: 0, 3625: 0, 7317: 0 };
            r.O.j = function (t) {
                return 0 === e[t];
            };
            var t = function (t, i) {
                    var n,
                        s,
                        o = i[0],
                        a = i[1],
                        l = i[2],
                        c = 0;
                    if (
                        o.some(function (t) {
                            return 0 !== e[t];
                        })
                    ) {
                        for (n in a) r.o(a, n) && (r.m[n] = a[n]);
                        if (l) var d = l(r);
                    }
                    for (t && t(i); c < o.length; c++) (s = o[c]), r.o(e, s) && e[s] && e[s][0](), (e[s] = 0);
                    return r.O(d);
                },
                i = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
            i.forEach(t.bind(null, 0)), (i.push = t.bind(null, i.push.bind(i)));
        })(),
        r.O(void 0, [1216], function () {
            return r(5122);
        });
    var n = r.O(void 0, [1216], function () {
        return r(157);
    });
    n = r.O(n);
})();
